import React from 'react';
import './App.css';
import FormPage from './containers/formPage/formPage';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import {createMuiTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/core/styles';
import * as Color from './constants/color';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: Color.PRIMARY_LIGHT,
            main: Color.PRIMARY_MAIN,
            dark: Color.PRIMARY_DARK,
            contrastText: Color.PRIMARY_CONTRAST_TEXT,
        },
        secondary: {
            light: Color.SECONDARY_LIGHT,
            main: Color.SECONDARY_MAIN,
            dark: Color.SECONDARY_DARK,
            contrastText: Color.SECONDARY_CONTRAST_TEXT,
        },
        contrastThreshold: 3,
        tonalOffset: 0.2,
    },
    typography: {
        h6: {
            fontSize: 15,
            letterSpacing: 0.5,
        },
    },
});

const store = configureStore();

function App() {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <FormPage />
            </ThemeProvider>
        </Provider>
    );
}

export default App;
